var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contArea tpd"},[_c('term-service-view',{attrs:{"terms":_vm.terms,"adTerms":_vm.adTerms}}),_c('button-apply',{attrs:{"before":"/"},on:{"submit":_vm.validate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }